/* Scripps Strategic Goals Section  */
import styled from 'styled-components';

export const ScrippsStrategicGoalsWrapper = styled.div`
.announcement-image {
    width: 150px;
    height: 90px;
    padding: 10px;
    border-radius: 4px;
}

.announcements-control {
    margin-bottom: 0px;
}

.announcements-control li {
    background-color: #0058b9 !important;
}

.announcements {
    padding: 5px 5px 5px 5px;
    margin-right: 4px;
    text-align: center;
    width: 90px;
}

.announcement-media p {
    font-size: 13px;
    line-height: 1.5;
    font-family: roboto, SFUIDisplay-Regular, --apple-system;
}

.announcement-media h6 {
    font-size: 18px;
    font-weight: bold;
    font-family: roboto, SFUIDisplay-Regular, --apple-system;
}

.carousel-announcement {
    padding: 0px 28px 10px 28px;
}
.carousel-inner{
    padding-top: 0px !important;
    padding-right: 28px !important;
    padding-bottom: 10px !important;
    padding-left: 28px !important;

}

.announcements-sec .card-body h5 {
    font-size: 16px;
}
.strategicgoals-image {
    width: 150px;
    height: 90px;
    padding: 10px;
    border-radius: 4px;
}

.strategicgoals-control {
    margin-bottom: 0px;
    bottom: 20px;
}

.strategicgoals-control li {
    background-color: #d8d8d8;
    width: 10px;
    height: 10px;
    border-radius: 100%;
}

.carousel-indicators .active {
    opacity: 1;
    background-color: #083ac8;
}

.carousel-control-next,
.carousel-control-prev {
    width: 20px;
    opacity: 1;
}
.carousel-control-next {
    right: -5px;
}
.carousel-control-prev {
    left: -5px;
}
.carousel-control-next i,
.carousel-control-prev i {
    color: #07639d;
    font-size: 20px
}
.strategicgoals {
    padding: 5px 5px 5px 5px;
    margin-right: 4px;
    text-align: center;
    width: 90px;
}

.strategicgoals-media p {
    font-size: 13px;
    line-height: 1.5;
    font-family: roboto, SFUIDisplay-Regular, --apple-system;
}

.strategicgoals-media h6 {

    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #333333;
}

.carousel-strategicgoals {
    padding: 0px 28px 10px 28px;
}
.strategic-goals{
    height: 100%;
}
.strategic-goals .carousel{
    height: 100%;  
}
.strategic-goals .card-body h5 {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #333333;
}
.strategic-content p{
    font-size: 16px;
  letter-spacing: normal;
  color: #333333;
}
.carousel-control-next{

}
.slick-prev::before {
    content: "\f053";
    position: absolute;
    color: #07639D;
    font-size: 20px;
    font-weight: 900;
    font-family: "Font Awesome 5 Free";
}
.slick-next::before {
    content: "\f054";
    position: absolute;
    color: #07639D;
    font-size: 20px;
    font-weight: 900;
    font-family: "Font Awesome 5 Free";
}
.slick-next {
    right: -3px !important;
}
.slick-prev {
    left: -19px !important;
}
.slick-dots li button:before {
    font-size: 13px !important;
    ;
}
.slick-dots li.slick-active button:before {
    opacity: 1;
    color: #083AC8 !important;
    ;
}
.slick-dots li button:hover:before,
.slick-dots li button:focus:before {
    opacity: 1;
}
.slick-dots li button:before {
    opacity: 1;
    background-color: #D8D8D8;
}
.slick-slider {
    padding: 0 20px !important;
}
.slick-dots li button:before {
    background-color: transparent !important;
    color: #D8D8D8 !important;
}
`;